import { render, staticRenderFns } from "./icon-synchronizer-folder.vue?vue&type=template&id=79163916&"
import script from "./icon-synchronizer-folder.vue?vue&type=script&lang=ts&"
export * from "./icon-synchronizer-folder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports